import { ReactComponent as CrossIcon } from 'assets/icon/x-circle.svg';
import PrimaryDarkButton from 'components/common/buttons/primary-dark-btn';
import DarkButton from 'components/common/buttons/dark-btn';
import { useAppDispatch, useAppSelector } from 'hooks/useAppDispatchSelector';
import { initModal, formatLocalizedDate } from 'helpers/utils';
import { setModal } from 'store/features/modelSlice';
import { useTranslation } from 'react-i18next';

const Step2: React.FC<{ handleSteps: (data: string) => void }> = ({ handleSteps = () => {} }) => {
  const dispatch = useAppDispatch();
  const { workshopAppointmentDetails } = useAppSelector(state => state.workShopAppointment);
  const { t } = useTranslation();
  const {
    modal: {
      content: { callBackFun },
    },
  } = useAppSelector(state => state.modal);
  return (
    <>
      <div className="flex items-center w-full">
        <div className="flex items-center flex-1">
          <label className="pl-2 text-xl font-semibold text-black2">
            {t('workshopAppointment.steps.paymentConfirmationlabel')}
          </label>
        </div>
        <div
          className="flex items-center justify-center cursor-pointer"
          onClick={() => dispatch(setModal(initModal))}
        >
          <CrossIcon height={32} width={32} />
        </div>
      </div>
      <span className="font-medium mx-2">{t('workshopAppointment.steps.createPayment')}</span>
      <div className="flex flex-wrap w-full overflow-y-auto max-h-[calc(100vh-250px)] gap-y-1 bg-grey4 rounded-4 p-4">
        <div className="flex items-center w-full gap-x-2">
          <label className="font-medium text-sm">{t('workshopAppointment.steps.timed')}:</label>
          <label className="text-sm">
            {formatLocalizedDate(
              workshopAppointmentDetails?.slot
                ? `${workshopAppointmentDetails.slot.date} ${workshopAppointmentDetails.slot.start_time}`
                : null,
              t,
              true,
              'YYYY-MM-DD HH:mm',
            )}
          </label>
        </div>
        <div className="flex items-center w-full gap-x-2">
          <label className="font-medium text-sm">
            {t('workshopAppointment.tableHeaders.service_type')}:
          </label>
          <label className="text-sm">
            {workshopAppointmentDetails?.other_service_type
              ? workshopAppointmentDetails?.other_service_type
              : workshopAppointmentDetails?.alert_details
              ? workshopAppointmentDetails?.alert_details?.title
              : '-'}
          </label>
        </div>
      </div>
      <div className="flex items-center justify-center w-full gap-x-4 mt-4">
        <PrimaryDarkButton label={'Yes'} onClick={() => handleSteps('PAYMENT')} width="w-1/2" />
        <DarkButton
          label="No"
          width="w-1/2"
          onClick={() => {
            callBackFun && callBackFun();
            dispatch(setModal(initModal));
          }}
        />
      </div>
    </>
  );
};

export default Step2;
